import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light", // 'light' | 'dark' | 'system'
  resolvedMode: "light",
  // typeof window !== "undefined"
  //   ? window.matchMedia("(prefers-color-scheme: dark)").matches
  //     ? "dark"
  //     : "light"
  //   : "light",
};

const theme = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setMode: (state, action) => {
      state.mode = action.payload;
      // if (action.payload !== "system") {
      //   state.resolvedMode = action.payload;
      // } else {
      //   state.resolvedMode = window.matchMedia("(prefers-color-scheme: dark)")
      //     .matches
      //     ? "dark"
      //     : "light";
      // }
    },
  },
});

export const { setMode } = theme.actions;
export const selectTheme = (state) => state.theme;
export default theme.reducer;
